import getScenarioStore from '../selectors/getScenarioStore';
import { mutator } from 'satcheljs';
import { setDisplayedQFRequestTime } from '../actions/publicActions';

export default mutator(setDisplayedQFRequestTime, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).displayedQFRequestTime =
        actionMessage.displayedQFRequestTime;
});
